import type { Permission } from '@ztechapps/common.contract'

export const returnOrderPermissions = {
  canView: {
    value: 'returnOrder.canView',
    label: 'Can View',
    description: 'No modification can be done to the returnOrder, only viewing of details.',
  } satisfies Permission,
  canEdit: {
    value: 'returnOrder.canEdit',
    label: 'Can Edit',
    description: 'Can modify the records for all fields of returnOrder',
  } satisfies Permission,
  canDelete: {
    value: 'returnOrder.canDelete',
    label: 'Can Delete',
    description:
      'Can delete the records for all fields of returnOrder. This will delete entire record and cannot be recovered.',
  } satisfies Permission,
}
